<template>
  <div>
    <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: `StatisticsByMakerChart`,

  props: {
    interventions: Array,
    makers: Array,
  },

  data: () => ({
  }),

  computed: {
    byMakerInterventions() {
      const byMakerInterventions = {};

      this.interventions.forEach(intervention => {
        const maker = _.find(this.makers, { id: intervention.Maker_id });
        if (!maker) { return; }
        if (!byMakerInterventions[maker.id]) {
          byMakerInterventions[maker.id] = [];
        }
        byMakerInterventions[maker.id].push({
          ...intervention,
          maker,
        });
      });

      return byMakerInterventions;
    },
    byMakerSerie() {
      const byMakerSerie = this.makers.map(maker => ({
        ...maker,
        count: (this.byMakerInterventions[maker.id] || []).length,
      }));

      return _.orderBy(byMakerSerie, `count`, `desc`);
    },
    nbMakers() {
      const { byMakerInterventions } = this;

      if (!byMakerInterventions) { return 0; }

      return Object.keys(byMakerInterventions).length;
    },
    chartheight() {
      return Math.max(this.nbMakers * 40, 200);
    },

    series() {
      return [{
        name: `Interventions`,
        data: _.map(this.byMakerSerie, `count`),
      }];
    },
    chartOptions() {
      return {
        chart: {
          type: `bar`,
          height: this.chartheight,
          toolbar: {
            show: false,
          },
        },
        title: {
          text: `Prestataires`,
        },
        colors: [`#008ffb`],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        legend: {
          show: false,
        },
        labels: _.map(this.byMakerSerie, `name`),
      };
    },
  },
};
</script>

<style lang="scss">
</style>
